const getFileUrl = (file?: string | null) => {
  if (!file) {
    return "";
  }

  // Some settings (e.g. an organization logo uploaded straight to object
  // storage) already hold a full URL. Prefixing those with the uploads base
  // produced "undefined/https://..." and a broken image.
  if (/^(https?:)?\/\//i.test(file) || file.startsWith("data:")) {
    return file;
  }

  const backendUrl = import.meta.env?.VITE_PUBLIC_UPLOADS_URL as
    | string
    | undefined;

  if (!backendUrl) {
    return file;
  }

  return `${backendUrl.replace(/\/+$/, "")}/${file.replace(/^\/+/, "")}`;
};

export default getFileUrl;
